import {Mixin} from "mixwith";

export const StateMixin = Mixin(superClass => class extends superClass {

	static get properties() {
		return {
			isDisabled: { type: Boolean, attribute: "disabled", reflect: true },
			isFocused: { type: Boolean, attribute: "focused", reflect: true }
		};
	}

	constructor() {
		super();
		this._boundFocusBlurHandler = this._focusBlurHandler.bind(this);

		this.isDisabled = false;
		this.isFocused = false;
	}

	connectedCallback() {
		super.connectedCallback();
		this.addEventListener("focus", this._boundFocusBlurHandler, true);
		this.addEventListener("blur", this._boundFocusBlurHandler, true);
	}

	disconnectedCallback() {
		this.removeEventListener("blur", this._boundFocusBlurHandler, true);
		this.removeEventListener("focus", this._boundFocusBlurHandler, true);
		super.disconnectedCallback();
	}

	update(changedProperties) {
		super.update(changedProperties);

		if(changedProperties.has("isDisabled")) {
			this.style.pointerEvents = this.isDisabled ? "none" : "";

			if(this.isDisabled) {
				// Removes any tabindex to prevent focus
				this._oldTabIndex = this.getAttribute("tabindex");
				this.isFocused = false;
				this.setAttribute("tabindex", -1);
				this.blur();
			} else if(this._oldTabIndex !== undefined) {
				// Restore tabindex if any
				if(this._oldTabIndex === null) {
					this.removeAttribute("tabindex");
				} else {
					this.setAttribute("tabindex", this._oldTabIndex);
				}
			}

			// ARIA: Announce disabled
			this.setAttribute("aria-disabled", this.isDisabled ? "true" : "false");
		}
	}

	_focusBlurHandler(e) {
		if(e.target === this)
			this.isFocused = e.type === "focus";
	}

});

export default StateMixin;